import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { ThemeOptions, ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import TierBadge from '@wix/da-ds/pkg/Badges/TierBadge';
import s from './TierPromotion.scss';
export var TierPromotion = function (_a) {
    var className = _a.className;
    var t = useTranslation().t;
    return (React.createElement(ThemeOverride, { theme: ThemeOptions.DARK },
        React.createElement("div", { className: classnames(s['root'], className) },
            React.createElement(TierBadge, { size: 24, className: s['badge'] }),
            React.createElement("div", { className: s['text'] }, t('avatar.tierPromotion.body')))));
};
TierPromotion.displayName = 'TierPromotion';
export default TierPromotion;
//# sourceMappingURL=TierPromotion.js.map